// Web-compatible logger adapter
export const logger = {
  debug: (...args: any[]) => console.debug('[Voice]', ...args),
  info: (...args: any[]) => console.info('[Voice]', ...args),
  warn: (...args: any[]) => console.warn('[Voice]', ...args),
  error: (...args: any[]) => console.error('[Voice]', ...args),
};
